
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {OrderWithAccount} from '../core/OrderWithAccount';
import {FieldModelOrderWithAccount} from '../core/OrderWithAccount';

/**
 * OrdersGetPageResponse struct
 */
class OrdersGetPageResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Array=} orderWithAccounts
   * @param {!number=} recordsTotal
   * @param {!number=} pageSize
   * @param {!number=} pageNumberZeroBased
   * @param {!boolean=} hasPersonalDetails
   * @constructor
   */
  constructor (parent = new Response(), orderWithAccounts = [], recordsTotal = new UInt64(0, 0), pageSize = new UInt64(0, 0), pageNumberZeroBased = new UInt64(0, 0), hasPersonalDetails = false) {
    super()
    super.copy(parent)
    this.OrderWithAccounts = orderWithAccounts
    this.RecordsTotal = recordsTotal
    this.PageSize = pageSize
    this.PageNumberZeroBased = pageNumberZeroBased
    this.HasPersonalDetails = hasPersonalDetails
  }

  /**
   * Copy struct (shallow copy)
   * @this {!OrdersGetPageResponse}
   * @param {!OrdersGetPageResponse} other Other struct
   * @returns {!OrdersGetPageResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.OrderWithAccounts != null) {
      this.OrderWithAccounts = []
      for (let item of other.OrderWithAccounts) {
        if (item != null) {
          let tempItem
          tempItem = OrderWithAccount.fromObject(item)
          this.OrderWithAccounts.push(tempItem)
        } else {
          this.OrderWithAccounts.push(null)
        }
      }
    } else {
      this.OrderWithAccounts = null
    }
    if (other.RecordsTotal != null) {
      this.RecordsTotal = UInt64.fromNumber(other.RecordsTotal)
    } else {
      this.RecordsTotal = null
    }
    if (other.PageSize != null) {
      this.PageSize = UInt64.fromNumber(other.PageSize)
    } else {
      this.PageSize = null
    }
    if (other.PageNumberZeroBased != null) {
      this.PageNumberZeroBased = UInt64.fromNumber(other.PageNumberZeroBased)
    } else {
      this.PageNumberZeroBased = null
    }
    if (other.HasPersonalDetails != null) {
      this.HasPersonalDetails = other.HasPersonalDetails
    } else {
      this.HasPersonalDetails = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!OrdersGetPageResponse}
   * @returns {!OrdersGetPageResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new OrdersGetPageResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new OrdersGetPageResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!OrdersGetPageResponse}
   * @param {!OrdersGetPageResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrdersGetPageResponse)) {
      throw new TypeError('Instance of OrdersGetPageResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!OrdersGetPageResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      OrderWithAccounts: ((this.OrderWithAccounts != null) ? Array.from(this.OrderWithAccounts, item => ((item != null) ? item : null)) : null),
      RecordsTotal: ((this.RecordsTotal != null) ? this.RecordsTotal.toNumber() : null),
      PageSize: ((this.PageSize != null) ? this.PageSize.toNumber() : null),
      PageNumberZeroBased: ((this.PageNumberZeroBased != null) ? this.PageNumberZeroBased.toNumber() : null),
      HasPersonalDetails: ((this.HasPersonalDetails != null) ? this.HasPersonalDetails : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return OrdersGetPageResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!OrdersGetPageResponse} other Object value
   * @returns {!OrdersGetPageResponse} Created struct
   */
  static fromObject (other) {
    return new OrdersGetPageResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!OrdersGetPageResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return OrdersGetPageResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!OrdersGetPageResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6471
  }
}

export { OrdersGetPageResponse };

/**
 * Fast Binary Encoding OrdersGetPageResponse field model
 */
class FieldModelOrdersGetPageResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.OrderWithAccounts = new fbe.FieldModelVector(new FieldModelOrderWithAccount(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.RecordsTotal = new fbe.FieldModelUInt64(buffer, this.OrderWithAccounts.fbeOffset + this.OrderWithAccounts.fbeSize)
    this.PageSize = new fbe.FieldModelUInt64(buffer, this.RecordsTotal.fbeOffset + this.RecordsTotal.fbeSize)
    this.PageNumberZeroBased = new fbe.FieldModelUInt64(buffer, this.PageSize.fbeOffset + this.PageSize.fbeSize)
    this.HasPersonalDetails = new fbe.FieldModelBool(buffer, this.PageNumberZeroBased.fbeOffset + this.PageNumberZeroBased.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.OrderWithAccounts.fbeSize + this.RecordsTotal.fbeSize + this.PageSize.fbeSize + this.PageNumberZeroBased.fbeSize + this.HasPersonalDetails.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.OrderWithAccounts.fbeExtra + this.RecordsTotal.fbeExtra + this.PageSize.fbeExtra + this.PageNumberZeroBased.fbeExtra + this.HasPersonalDetails.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelOrdersGetPageResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6471
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderWithAccounts.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.OrderWithAccounts.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderWithAccounts.fbeSize

    if ((fbeCurrentSize + this.RecordsTotal.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RecordsTotal.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RecordsTotal.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PageSize.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.PageNumberZeroBased.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PageNumberZeroBased.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageNumberZeroBased.fbeSize

    if ((fbeCurrentSize + this.HasPersonalDetails.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.HasPersonalDetails.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HasPersonalDetails.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {!OrdersGetPageResponse} fbeValue Default value, defaults is new OrdersGetPageResponse()
   * @returns {!OrdersGetPageResponse} OrdersGetPageResponse value
   */
  get (fbeValue = new OrdersGetPageResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {!OrdersGetPageResponse} fbeValue OrdersGetPageResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.OrderWithAccounts.fbeSize) <= fbeStructSize) {
      this.OrderWithAccounts.get(fbeValue.OrderWithAccounts)
    } else {
      fbeValue.OrderWithAccounts.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.OrderWithAccounts.fbeSize

    if ((fbeCurrentSize + this.RecordsTotal.fbeSize) <= fbeStructSize) {
      fbeValue.RecordsTotal = this.RecordsTotal.get(new UInt64(0, 0))
    } else {
      fbeValue.RecordsTotal = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RecordsTotal.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) <= fbeStructSize) {
      fbeValue.PageSize = this.PageSize.get(new UInt64(0, 0))
    } else {
      fbeValue.PageSize = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.PageNumberZeroBased.fbeSize) <= fbeStructSize) {
      fbeValue.PageNumberZeroBased = this.PageNumberZeroBased.get(new UInt64(0, 0))
    } else {
      fbeValue.PageNumberZeroBased = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageNumberZeroBased.fbeSize

    if ((fbeCurrentSize + this.HasPersonalDetails.fbeSize) <= fbeStructSize) {
      fbeValue.HasPersonalDetails = this.HasPersonalDetails.get(false)
    } else {
      fbeValue.HasPersonalDetails = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.HasPersonalDetails.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelOrdersGetPageResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {!OrdersGetPageResponse} fbeValue OrdersGetPageResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelOrdersGetPageResponse}
   * @param {OrdersGetPageResponse} fbeValue OrdersGetPageResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.OrderWithAccounts.set(fbeValue.OrderWithAccounts)
    this.RecordsTotal.set(fbeValue.RecordsTotal)
    this.PageSize.set(fbeValue.PageSize)
    this.PageNumberZeroBased.set(fbeValue.PageNumberZeroBased)
    this.HasPersonalDetails.set(fbeValue.HasPersonalDetails)
  }
}

export { FieldModelOrdersGetPageResponse };

/**
 * Fast Binary Encoding OrdersGetPageResponse model
 */
class OrdersGetPageResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelOrdersGetPageResponse(this.buffer, 4)
  }

  /**
   * Get the OrdersGetPageResponse model
   * @this {!OrdersGetPageResponseModel}
   * @returns {!FieldModelOrdersGetPageResponse} model OrdersGetPageResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!OrdersGetPageResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!OrdersGetPageResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return OrdersGetPageResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!OrdersGetPageResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelOrdersGetPageResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!OrdersGetPageResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!OrdersGetPageResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!OrdersGetPageResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!OrdersGetPageResponseModel}
   * @param {!OrdersGetPageResponse} value OrdersGetPageResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!OrdersGetPageResponseModel}
   * @param {!OrdersGetPageResponse} value OrdersGetPageResponse value, defaults is new OrdersGetPageResponse()
   * @return {!object} Deserialized OrdersGetPageResponse value and its size
   */
  deserialize (value = new OrdersGetPageResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new OrdersGetPageResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new OrdersGetPageResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!OrdersGetPageResponseModel}
   * @param {!number} prev Previous OrdersGetPageResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { OrdersGetPageResponseModel };
